export const PrivacyPolicyScreen = () => {
	return (
		<div className="container mx-auto mt-5 p-6 bg-white rounded-xl shadow-md max-w-md">
			<h1 className="text-2xl font-bold mb-6 text-center">Privacy Policy</h1>
			<p className="mb-4 text-sm text-gray-500 text-center">
				Last Updated: October 10th 2023
			</p>

			<div className="mb-4">
				<p>
					This Privacy Policy describes how <strong>Guillem Curriculum</strong>{" "}
					("we", "our", or "us") protects and makes use of the information you
					provide when you use our Android app, iOS app, and website. We take
					your privacy extremely seriously, and we're committed to ensuring the
					best standards for data protection.
				</p>
			</div>

			<h2 className="text-xl font-semibold mb-2">Information We Collect</h2>
			<p className="mb-4">
				We do not collect any personal data or information when you use our
				Android app, iOS app, or website. Our primary aim is to provide you with
				functionality without compromising your privacy.
			</p>

			<h2 className="text-xl font-semibold mb-2">Data Protection</h2>
			<p className="mb-4">
				Even though we do not collect personal data, we prioritize the
				protection of any data and information that is processed during the
				functionality of our services. We use standard industry protocols to
				safeguard against unauthorized access to our systems.
			</p>

			<h2 className="text-xl font-semibold mb-2">Third-party Services</h2>
			<p className="mb-4">
				Our apps and website may contain links to third-party websites or
				services that are not operated by us. Please be aware that we have no
				control over the content and practices of these sites, and cannot take
				responsibility for their treatment of your personal information. We
				recommend you review the privacy policies of any third-party sites that
				you visit via our services.
			</p>

			<h2 className="text-xl font-semibold mb-2">
				Changes to This Privacy Policy
			</h2>
			<p className="mb-4">
				We reserve the right to make changes to this Privacy Policy in the
				future. Any changes will be updated here, so we advise checking this
				page regularly to ensure you are aware of any updates.
			</p>
		</div>
	);
};
